/* eslint-disable import/prefer-default-export */
import axios from "axios";
import gql from "graphql-tag";
import getMaintenanceMode, { getFingerprint } from "../../utilities";

const graphql = require("graphql");

const { print } = graphql;

interface SessionDetails {
  correlationId: string;
  brand: string;
  country: string;
  source: string;
  language: string;
  token: string;
  shouldLinkAccount?: boolean;
}

interface Payload {
  partyId: number;
  mfaCode: string;
  rememberDevice: boolean;
  sessionDetails: SessionDetails;
}

const gqlRequest = gql`
  query VerifyCustomerAuthenticatorCodeIntegrated($Request: VerifyCustomerAuthenticatorCodeIntegratedRequest!) {
    verifyCustomerAuthenticatorCodeIntegrated(Request: $Request) {
      DefaultAccountNumber
      IsCodeVerified
      IsSuccess
      Errors {
        ErrorCode
        ErrorStack
        ErrorMessage
      }
      LoginAttemptCount
      PartyId
      Token {
        AccessToken
        ExpiresIn
        IdToken
        RefreshToken
        TokenType
      }
    }
  }
`;

export const verifyCustomerAuthenticatorCodeIntegrated = async (payload: Payload) => {
  const { mfaCode, partyId, rememberDevice, sessionDetails } = payload;
  try {
    const userFingerprint = await getFingerprint();
    const getMode = await getMaintenanceMode();
    if (getMode === true) {
      return {
        data: {
          inMaintenance: "Y",
        },
      };
    }
    const request = {
      PartyId: partyId,
      CorrelationId: sessionDetails.correlationId,
      Brand: sessionDetails.brand,
      Country: sessionDetails.country,
      AuthenticatorCode: `${mfaCode}`,
      Fingerprint: `${userFingerprint}`,
      RememberMe: rememberDevice,
      ShouldLinkAccount: sessionDetails.shouldLinkAccount ?? false,
      ParentFunctionName: "VerifyMFACode",
      ProcessName: "VerifyMFACode",
      SourceApp: sessionDetails.source,
      WidgetName: sessionDetails.source,
    };
    const appsyncUrl = process.env.REACT_APP_APPSYNC_URL ?? '';
    const url = `${appsyncUrl}/customerauth/authenticated/graphql`;
    const response = await axios({
      url: url,
      method: "post",
      headers: {
        "Authorization": sessionDetails.token,
      },
      data: {
        query: print(gqlRequest),
        variables: {
          Request: request,
        },
      },
    });
    const verifyResponse = response?.data?.data?.verifyCustomerAuthenticatorCodeIntegrated;
    if (
      verifyResponse?.IsSuccess &&
      verifyResponse?.IsCodeVerified
    ) {
      return {
        data: {
          isSuccess: true,
          isVerified: true,
          token: verifyResponse?.Token?.IdToken,
          accountNumber: verifyResponse?.DefaultAccountNumber,
        },
      };
    }
    if (typeof verifyResponse?.LoginAttemptCount === 'number') {
      return {
        data: {
          isSuccess: true,
          isVerified: false,
          loginAttemptCount: verifyResponse?.LoginAttemptCount,
        },
      };
    }
    if (
      verifyResponse?.Errors ||
      response?.data?.data === null
    ) {
      return {
        data: {
          isSuccess: true,
          errors:
            verifyResponse?.Errors ||
            response?.data?.errors ||
            "",
        },
      };
    }
    return {
      data: {
        isSuccess: false,
        error:
          response?.data?.errors ||
          response?.data?.data?.error ||
          response?.data ||
          response,
      },
    };
  } catch (error) {
    const normalizedError = error as Error;
    return { error: normalizedError.message || normalizedError.toString() };
  }
};
